module.exports = "<div class=\"action warn\" *ngIf=\"dues.length && showInvoice\">\n  <h2>You have pending invoices for an amount of Rupees {{total}}\n  </h2>\n\n  <i (click)=\"hideBanner()\" class=\"fa fa-times\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/invoice-banner/invoice-banner.component.html
// module id = ../../../../../src/app/shared/components/invoice-banner/invoice-banner.component.html
// module chunks = main